<template>
    <div class="talent-info">
        <baseInfoWrap titleColor="#d3d5da" textColor="#e9eaed" title="JUE SE TIAN FU">
            <div class="talent-info-wrap">
                <div class="talent-info-title">天賦</div>
                <div class="talent-info-detail">
                    <div class="talent-info-detail-icon">
                        <img :src="talentData.icon" alt="">
                    </div>
                    <div class="talent-info-detail-content">
                        <div class="talent-detail talent-type">
                            <p class="talent-detail-title">類型：</p>
                            <p class="talent-detail-content">{{ talentData && talentData.type ? talentData.type : '-' }}</p>
                        </div>
                        <div class="talent-detail talent-expend">
                            <p class="talent-detail-title">消耗：</p>
                            <p class="talent-detail-content">{{ talentData && talentData.expend ? talentData.expend : '-' }}
                            </p>
                        </div>
                        <div class="talent-detail talent-weapon">
                            <p class="talent-detail-title">武器：</p>
                            <p class="talent-detail-content">{{ talentData && talentData.weapon ? talentData.weapon : '-' }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="talent-info-name">{{ talentData.name }}</div>
                <div class="talent-info-desc" v-html="talentData.desc || ''"></div>
            </div>
        </baseInfoWrap>
    </div>
</template>

<script>
import baseInfoWrap from './base/baseInfoWrap.vue';
export default {
    components: { baseInfoWrap },
    props: {
        originData: {
            type: Object,
            default: () => { }
        },
        isFullLevel:{
            type: Boolean,
            default: false
        }
    },
    computed: {
        talentData() {
            let data = this.originData && this.originData.talentData ? this.originData.talentData : {origin: {},full:{}}
            if(data.origin && data.full){
                return this.isFullLevel ? data.full : data.origin
            }else{
                return {}
            }
        }
    }
}
</script>

<style scoped lang="scss">
.talent-info {
    height: 100%;

    .talent-info-wrap {
        height: 100%;
        padding: .15rem;
        box-sizing: border-box;
        background-color: white;

        .talent-info-title {
            width: 100%;
            font-size: .24rem;
            margin-bottom: .05rem;
        }

        .talent-info-detail {
            height: 1.07rem;
            display: flex;
            margin-bottom: .15rem;

            &-icon {
                position: relative;
                height: 100%;
                width: 1.07rem;
                background-color: #f2f2f4;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: .03rem;

                img {
                    width: 50%;
                    height: 50%;
                    object-fit: contain;
                    object-position: center;
                }
            }

            &-content {
                flex: 1;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;

                .talent-detail {
                    width: 100%;
                    height: .33rem;
                    font-size: .22rem;
                    font-weight: bold;
                    background-color: #f2f2f4;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    &-title {
                        width: 30%;
                        text-align: center;
                    }

                    &-content {
                        flex: 1;
                        text-align: center;
                        color: #404040;
                    }

                    &.talent-type {
                        font-weight: bold;
                    }
                }
            }
        }

        .talent-info-name {
            width: 100%;
            font-size: .24rem;
            margin-bottom: .11rem;
        }

        .talent-info-desc {
            font-size: .20rem;
            color: #404040;
        }
    }

}</style>